module.exports = __webpack_public_path__ + "static/media/Youtube.4f6652df.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Youtube.svg
// module id = 1920
// module chunks = 1